export const fuzzySearchThreshold = -1000

export const maxWaitRecommendationsTimeout = 3 * 60 * 1000

export const focusedTypes = {
  ACCOUNT: 'account',
  GROUP: 'group',
} as const

export type FocusedTypes = typeof focusedTypes[keyof typeof focusedTypes]

export const accountTableRowStatuses = {
  UNCERTAIN: '01.uncertain',
  EDITED: '02.edited',
  NONE: '03.none',
}

export type AccountTableRowStatus =
  typeof accountTableRowStatuses[keyof typeof accountTableRowStatuses]
